import React, { useEffect, useState, useCallback } from "react";
import { Space, message, Table, Button, Typography, Tabs, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Util from "../../Util";

const { Title, Paragraph } = Typography;

function Vendor() {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const [vendorListWithVid, setVendorListWithVid] = useState([]);
  const [vendorListWithoutVid, setVendorListWithoutVid] = useState([]);

  const loadVendors = useCallback(async () => {
    try {
      setLoading(true);
      setLoadedCount(0);
      let retSize = 5000;
      let result = [];
      let cursor = "";
      while (retSize === 5000) {
        const data = await Util.sendGet("/api/moresheetStaff/getVendorReport", {
          cursor: cursor,
        });
        if (!data.success) {
          messageApi.error("เกิดข้อผิดพลาด กรุณา refresh!");
          break;
        }
        result = [...result, ...data.data];
        cursor = data.data[data.data.length - 1]._id;
        retSize = data.data.length;
        setLoadedCount(result.length);
      }
      result = result.map((row) => {
        return {
          htiVendorId: row.htiVendorId || "",
          htiVendorName: row.htiVendorName || "",
          facebookID: row.facebookID,
          codeName: row.codeName,
          realName: row.realName,
          peopleID: row.peopleID,
          email: row.email,
          phone: row.phone,
          payBank:
            row.bankInfo.split(",").length === 2
              ? row.bankInfo.split(",")[0]
              : "Invalid",
          payAccNumber:
            row.bankInfo.split(",").length === 2
              ? row.bankInfo.split(",")[1]
              : "Invalid",
          address: `${row.addSmall} ${row.addSmallDistrict} ${row.addDistrict}`,
          province: row.addProvince,
          addPostal: row.addPostal,
        };
      });
      setVendorListWithVid(result.filter((row) => row.htiVendorId));
      setVendorListWithoutVid(result.filter((row) => !row.htiVendorId));
    } catch (err) {
      messageApi.error("เกิดข้อผิดพลาด กรุณา refresh!");
    }
    setLoading(false);
  }, [messageApi]);

  useEffect(() => {
    loadVendors();
  }, [loadVendors]);

  const columns = [
    {
      title: "HTI Vendor ID",
      dataIndex: "htiVendorId",
      key: "htiVendorId",
    },
    {
      title: "HTI Vendor Name",
      dataIndex: "htiVendorName",
      key: "htiVendorName",
    },
    {
      title: "รหัสผู้ใช้",
      dataIndex: "facebookID",
      key: "facebookID",
    },
    {
      title: "นามปากกา",
      dataIndex: "codeName",
      key: "codeName",
    },
    {
      title: "ชื่อจริง",
      dataIndex: "realName",
      key: "realName",
    },
    {
      title: "บัตรประชาชน",
      dataIndex: "peopleID",
      key: "peopleID",
    },
    {
      title: "ธนาคาร",
      dataIndex: "payBank",
      key: "payBank",
    },
    {
      title: "เลขบัญชี",
      dataIndex: "payAccNumber",
      key: "payAccNumber",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "โทรศัพท์",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "จังหวัด",
      dataIndex: "province",
      key: "province",
    },
    {
      title: "รหัสไปรษณีย์",
      dataIndex: "addPostal",
      key: "addPostal",
    },
  ];
  const noVendorIdColumns = columns.filter(
    (col) => !["htiVendorName", "htiVendorId"].includes(col.dataIndex)
  );

  const downloadAsCsv = (inpData, inpCol, fileName) => {
    const data = [];
    data.push(inpCol.map((col) => col.title).join(","));
    for (const x of inpData) {
      data.push(inpCol.map((col) => x[col.dataIndex]).join(","));
    }

    const text = data.join("\n");
    const blob = new Blob([text], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const sendUpdateVendorId = async (mapping) => {
    try {
      const data = await Util.sendPost("/api/moresheetStaff/updateVendorIds", {
        peopleIdtoVendorMap: mapping,
      });
      if (!data.success) {
        messageApi.error("Some error! Please retry later!");
        return;
      }
      messageApi.success(`update แล้ว ${data.matchedCount} ผู้ขาย`);
      loadVendors();
    } catch (err) {
      messageApi.error("Some error! Please retry later!");
    }
  };

  const WithVendorId = () => {
    return (
      <React.Fragment>
        <Button
          type="primary"
          size="large"
          onClick={() =>
            downloadAsCsv(
              vendorListWithVid,
              columns,
              "vendor_with_vendorid.csv"
            )
          }
        >
          Download as CSV
        </Button>
        <Table dataSource={vendorListWithVid} columns={columns} />
      </React.Fragment>
    );
  };

  const WithOutVendorId = () => {
    return (
      <React.Fragment>
        <Button
          type="primary"
          size="large"
          onClick={() =>
            downloadAsCsv(
              vendorListWithoutVid,
              noVendorIdColumns,
              "vendor_without_vendorid.csv"
            )
          }
        >
          Download as CSV
        </Button>
        <Table dataSource={vendorListWithoutVid} columns={noVendorIdColumns} />
      </React.Fragment>
    );
  };

  const UpdateVendorId = (props) => {
    const STAGE = {
      UPLOAD: 0,
      CHECK: 1,
    };

    const [stage, setStage] = useState(STAGE.UPLOAD);
    const [mapping, setMapping] = useState({});
    const [newData, setNewData] = useState([]);
    const [existingData, setExistingData] = useState([]);
    const [invalidData, setInvalidData] = useState([]);

    const fileChanged = async (file) => {
      try {
        const filedata = await Util.fileReaderAsync(file);
        const filelines = filedata.split("\n");
        const mapper = {};
        for (let i = 1; i < filelines.length; i++) {
          const line = filelines[i].trim().split(",");
          if (line.length < 3) continue;
          const vendorID = line[0];
          const vendorName = line[1];
          const peopleID = line[2];
          mapper[peopleID] = {
            htiVendorId: vendorID,
            htiVendorName: vendorName,
          };
        }

        // Cross with old data to create table
        const combinedVendorData = [
          ...vendorListWithVid,
          ...vendorListWithoutVid,
        ];
        const vendorMap = {};
        for (const row of combinedVendorData) {
          if (!vendorMap.hasOwnProperty(row.peopleID))
            vendorMap[row.peopleID] = [];
          vendorMap[row.peopleID].push(row);
        }
        const existing = [];
        const nonexisting = [];
        const invalid = [];
        Object.entries(mapper).map(([peopleID, obj]) => {
          const vendorID = obj.htiVendorId;
          const vendorName = obj.htiVendorName;
          if (!vendorMap.hasOwnProperty(peopleID)) {
            invalid.push({ peopleID, vendorName, vendorID });
            return null;
          }
          for (const vendor of vendorMap[peopleID]) {
            if (vendor.htiVendorId)
              existing.push({
                ...vendor,
                htiVendorId: `${vendor.htiVendorId} > ${vendorID}`,
                htiVendorName: `${vendor.htiVendorName} > ${vendorName}`,
              });
            else
              nonexisting.push({
                ...vendor,
                htiVendorId: vendorID,
                htiVendorName: vendorName,
              });
          }
          return null;
        });
        setExistingData(existing);
        setNewData(nonexisting);
        setInvalidData(invalid);

        setMapping(mapper);
        setStage(STAGE.CHECK);
      } catch (err) {
        messageApi.error("ไฟล์ไม่ถูกต้อง");
      }
    };

    const invalidDataColumns = [
      {
        title: "Vendor ID",
        dataIndex: "vendorID",
        key: "vendorID",
      },
      {
        title: "Vendor Name",
        dataIndex: "vendorName",
        key: "vendorName",
      },
      {
        title: "เลขบัตรประชาชน",
        dataIndex: "peopleID",
        key: "peopleID",
      },
    ];

    return (
      <React.Fragment>
        {stage === STAGE.UPLOAD && (
          <React.Fragment>
            <Paragraph>
              ไฟล์ csv มี header 1 แถว, column แรกคือ Vendor ID คอลัมน์ที่สองคือ
              Vendor Name คอลัมน์ที่สามคือเลขบัตรประชาชน ตัวอย่าง
            </Paragraph>
            <pre>
              <code>
                VendorId,VendorName,เลขบัตรประชาชน
                <br />
                HTI-S000001,HTI-นางสาวชยานันต์ บรรเทิง,1104200466187
                <br />
                HTI-S000002,HTI-นางสาว เมธาวี สมใจ,1102200219242
                <br />
                HTI-S000003,HTI-นางสาวธนพร ทั้งถิ่น,1101000126665
              </code>
            </pre>
            <Upload
              beforeUpload={fileChanged}
              accept=".csv"
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>Click to Upload .csv</Button>
            </Upload>
          </React.Fragment>
        )}
        {stage === STAGE.CHECK && (
          <React.Fragment>
            <Title>กรุณายืนยัน</Title>
            {invalidData.length > 0 && (
              <React.Fragment>
                <Paragraph type="danger">
                  ไม่พบผู้ขาย: {invalidData.length}
                </Paragraph>
                <Table dataSource={invalidData} columns={invalidDataColumns} />
              </React.Fragment>
            )}
            {existingData.length > 0 && (
              <React.Fragment>
                <Paragraph type="warning">
                  ผู้ขายที่มี VendorID อยู่แล้ว: {existingData.length}
                </Paragraph>
                <Table dataSource={existingData} columns={columns} />
              </React.Fragment>
            )}
            {newData.length > 0 && (
              <React.Fragment>
                <Paragraph type="success">
                  ผู้ขายที่ยังไม่มี VendorID: {newData.length}
                </Paragraph>
                <Table dataSource={newData} columns={columns} />
              </React.Fragment>
            )}
            <Button
              type="primary"
              size="large"
              onClick={() => props.sendUpdateVendorId(mapping)}
            >
              ยืนยันและส่งเข้าระบบ
            </Button>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const tabItems = [
    {
      key: "v1",
      label: "With VendorID",
      children: <WithVendorId />,
    },
    {
      key: "v2",
      label: "Without VendorID",
      children: <WithOutVendorId />,
    },
    {
      key: "update",
      label: "Update VendorID",
      children: <UpdateVendorId sendUpdateVendorId={sendUpdateVendorId} />,
    },
  ];

  return (
    <Space direction="vertical" size={12}>
      {contextHolder}
      {loading && (
        <div>กำลังโหลดข้อมูล vendor ได้แล้ว {loadedCount} รายการ</div>
      )}
      {!loading && <Tabs defaultActiveKey="1" items={tabItems} />}
    </Space>
  );
}

export default Vendor;
